import { ComponentType } from '@common/types';

export const desktopWidth = 1200;

export const devices: any = {
  iphoneProMax: {
    name: 'iPhone 11 Pro Max',
    width: 414,
    height: 896,
    category: 'iphoneProMax',
    type: 'iphone',
    clientWidth: 454,
    clientHeight: 936,
    ratio: 936 / 454,
  },
  iphonePro: {
    name: 'iPhone 11 Pro',
    width: 375,
    height: 812,
    category: 'iphonePro',
    type: 'iphonePro',
    clientWidth: 415,
    clientHeight: 852,
    ratio: 852 / 415,
  },
  iphone11: {
    name: 'iPhone 11',
    width: 375,
    height: 812,
    category: 'iphone11',
    type: 'iphone',
    clientWidth: 415,
    clientHeight: 852,
    ratio: 852 / 415,
  },
  iphoneSE: {
    name: 'iPhone SE',
    width: 375,
    height: 667,
    category: 'iphoneSE',
    type: 'iphoneSE',
    clientWidth: 415,
    clientHeight: 847,
    ratio: 847 / 415,
  },
  galaxyS20: {
    name: 'Galaxy S2O',
    width: 360,
    height: 740,
    category: 'galaxyS20',
    type: 'android',
    clientWidth: 400,
    clientHeight: 920,
    ratio: 920 / 400,
  },
  pixel4: {
    name: 'Pixel 4',
    width: 412,
    height: 824,
    category: 'pixel4',
    type: 'android',
    clientWidth: 452,
    clientHeight: 1004,
    ratio: 1040 / 452,
  },
  iPadPro: {
    name: 'iPad Pro',
    width: 1024,
    height: 1366,
    category: 'iPadPro',
    type: 'ipad',
    clientWidth: 1064,
    clientHeight: 1546,
    ratio: 1546 / 1064,
  },
  galaxyTab: {
    name: 'Galaxy Tab',
    width: 800,
    height: 1280,
    category: 'galaxyTab',
    type: 'android',
    clientWidth: 840,
    clientHeight: 1460,
    ratio: 1460 / 840,
  },
};

export const HOME_URL = 'https://click.dev';

export const HEIGHT_STATUS_BAR = 25;

export const DEVICE_NOT_TIMER = ['iphoneProMax', 'iphonePro', 'iphone11'];

export const APP_API_TOKEN = 'a1bde50f-e72d-4b2e-a4e8-21b33c31bb4c';

export const TOKEN_KEY = 'access_token';

export const defaultURL =
  'data:image/png;base64,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';

export const IMAGE_TYPE = {
  UPLOAD: 'uploaded',
  URL: 'url',
  BINDING: 'binding',
  INTERNAL: 'internal',
} as const;

export const BINDING_SELECTOR_TYPE = {
  CREATED_OBJECT: 'CREATED_OBJECT',
  CURRENT_USER_SELECTOR: 'CURRENT_USER_SELECTOR',
  ROUTE_PARAM_SELECTOR: 'ROUTE_PARAM_SELECTOR',
  LIST_ITEM_SELECTOR: 'LIST_ITEM_SELECTOR',
  SELECT_VALUE_SELECTOR: 'SELECT_VALUE_SELECTOR',
  CURRENT_RECORD: 'CURRENT_RECORD',
};

export const FIELD_TYPE = {
  DATE: 'date',
  CHARACTER: 'character',
  PASSWORD: 'password',
  INTEGER: 'integer',
  BOOLEAN: 'boolean',
  TIMESTAMP: 'timestamp',
  IMAGE: 'image',
  FILE: 'file',
  OBJECT: 'object',
  LIST: 'list',
  RELATIONSHIP: 'relationship',
};

export const COMPARATORS: any = {
  eq: '==',
  neq: '!=',
  contains: 'contains',
  notContains: 'notContains',
  empty: 'empty',
  notEmpty: 'notEmpty',
  gt: '>',
  lt: '<',
  gte: '>=',
  lte: '<=',
  between: 'between',
  listContains: 'listContains',
  listNotContains: 'listNotContains',
  lengthEqual: 'lengthEqual',
  lengthGreaterThan: 'lengthGreaterThan',
  lengthLessThan: 'lengthLessThan',
};

export const TABLE_ID_PATH = 'appDatabaseId';

export const RELATIONSHIP_TYPES = {
  '1n': 'hasManyRelation',
  n1: 'belongsToRelation',
  nn: 'manyToManyRelation',
};

export const DATE_TIME_FORMAT = 'L LTS';

export const dataTypes = {
  TEXT: 'text',
  DATE: 'date',
  DATE_ONLY: 'dateOnly',
  LOCATION: 'location',
  NUMBER: 'number',
  BOOLEAN: 'boolean',
  LIST: 'list',
  IMAGE: 'image',
  COLOR: 'color',
  ICON: 'icon',
  FILE: 'file',
  PASSWORD: 'password',
  OBJECT: 'object',
  FOREIGN_KEY: 'foreignKey',
  ACTION_REF: 'actionRef', // Control types (for libraries + inspector)
  USERNAME: 'username',
  EMAIL: 'email',
  FULL_NAME: 'full_name',
  TEMPORARY_PASSWORD: 'temporary_password',
  TEMPORARY_PASSWORD_EXPIRES_AT: 'temporary_password_expires_at', // Text Inputs
  SELECT: 'select',
  IMAGE_UPLOAD: 'image-upload',
  RADIO: 'radio',
  TOGGLE: 'toggle',
};

export const DATE_FORMAT = {
  DATE_ONLY: 'YYYY/MM/DD',
  LLL: 'LLL',
  DATE_LABEL_FORMAT: 'YYYY/MM/DD HH:mm',
  DATE_TIME_FORMAT: 'YYYY/MM/DD HH:mm:ss',
  RELATIVE: 'relative',
  RELATIVE_SHORT: 'relative_short',
  NONE_FORMAT: 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
};

export const DATE_TIME_FORMAT_CANVAS = {
  RELATIVE: 'relative',
  RELATIVE_SHORT: 'relative_short',
  DATE: 'YYYY/MM/DD',
  DATE_TIME: 'YYYY/MM/DD HH:mm:ss A',
  DATE_TIME_LESS: 'YYYY/MM/DD HH:mm',
  DAY_OF_WEEK: 'dddd',
  DAY_OF_WEEK_SHORT: 'ddd',
  TIME: 'hh:mm A',
  NONE: 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]',
};

export const ONE_DAY = 24 * 60 * 60 * 1000;

export const pathComponents = {
  title: 'title.text',
  subTitle: 'subTitle.text',
  subTitle2: 'subTitle2.text',
  image: 'cardCover.image',
  imageUrl: 'cardCover.imageUrl',
  tableId: 'database.idCollectionSelected',
  button1: 'button1.text',
  leftSection: 'leftSection',
  marker: 'marker.markerAddress',
  markers: 'markers.markerAddress',
  distanceSearch: 'markers.distanceSearch',
  selectedAddressMarker: 'markers.selectedAddressMarker',
  pinGeometry: {
    lng: 'markers.markerX',
    lat: 'markers.markerY',
  },
  tag: 'tag.text',
  footer: 'footer.text',
  avatarImage: 'avatarImage.image',
  avatarImageUrl: 'avatarImage.imageUrl',
  listMarkerImage: 'markers.listMarkerImage',
  listMarkerImageUrl: 'markers.imageUrl',
  simpleMarkerImage: 'marker.markerImage',
  simpleMarkerImageUrl: 'marker.imageUrl',
};

export const ANIMATION_MODE = {
  floatUp: 'fadeInUpBig',
  floatDown: 'fadeInDownBig',
  floatLeft: 'fadeInLeftBig',
  floatRight: 'fadeInRightBig',
  slideUp: 'slideInUp',
  slideDown: 'slideInDown',
  slideLeft: 'slideInLeft',
  slideRight: 'slideInRight',
  fadeIn: 'fadeIn',
  none: '',
};

export const componentName = {
  Image: 'image',
  Toggle: 'Toggle',
  TAB_NAVIGATOR: 'TabNavigator',
  BUTTON: 'Button',
  SIMPLE_LIST: 'SimpleList',
  CARD_LIST: 'CardList',
  TOGGLE: 'Toggle',
  MAP: 'Map',
  SWITCH: 'Switch',
  Icon: 'Icon',
  CALENDAR: 'Calendar',
  STRIPE_PAYMENT: 'StripePayment',
  STRIPE_PAYMENT_SECURITY: 'StripePaymentSecurity',
  STRIPE_SUBSCRIPTION: 'StripeSubscription',
  BARCODE: 'BarCode',
  BARCODESCANER: 'BarcodeScanner',
  QRCODE: 'QRCode',
  CAROUSEL: 'Carousel',
  HORIZONTAL_CARD_LIST: 'HorizontalCardList',
  CHIP_LIST: 'ChipList',
  AVATAR_LIST: 'AvatarList',
  UNIVAPAY: 'UnivaPay',
  UNIVAPAY_SUBSCRIPTION: 'UnivaPaySubscription',
  LIVE_STREAM_CAMERA: 'LiveStreamCamera',
  IMAGEUPLOADLIST: 'ImageUploadList',
  RANKING_LIST: 'RankingList',
  SELECT_LIST: 'SelectList',
  TORUS_LOGIN: 'TorusLogin',
  CUSTOM_HORIZONTAL_LIST: 'CustomHorizontalList',
  CUSTOM_BUTTON: 'CustomButton',
  LIVESTREAM_CHAT: 'LivestreamChat',
  CHANGE_QUANTITY: 'ChangeQuantity',
  IN_APP_PURCHASE: 'InAppPurchase',
  CUSTOMER_CHAT: 'CustomerChat',
  FINCODE: 'Fincode',
  BLOCTO: 'Blocto',
  GPT_CONVERSATION: 'GptConversation',
};

export const rowType = {
  STRING: 'string',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  IMAGE: 'image',
  FILE: 'file',
  ACTIONREF: 'actionRef',
  TAG: 'tag',
};

export const bindType = {
  INTERNAL: 'internal',
  UPLOADED: 'uploaded',
} as const;

export const PERMISSON = {
  ANYONE: 'anyone',
  NOBODY: 'nobody',
  RECORD_CREATOR: 'recordCreator',
  LOGGED_USER: 'loggedInUser',
};

export const pageSizeDefault = 20;

export const KEY_CRYPTO =
  'feacdc40838bd3ae53b3d003e59d561cd08d447daee32b07ec2157c0f7c57588';

export const MAILER_TOKEN = '9a49871d-b701-4342-b067-1d9b3575e181';

export const RESPONSE_STATUS = {
  VALID: 'valid',
  IN_VALID: 'invalid',
};

export const SPECIAL_CHARACTER_REGEX =
  /^[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s]*$/;

export const FIELD_NAME_SEND_MAIL: any = {
  to: 'Email address',
  content: 'Body',
  subject: 'Title',
};

export const refreshTime = {
  total: 1000,
  step: 0.1,
  round: 100,
  stop: 0.99,
};

export const GOOGLE_API_KEY = 'AIzaSyDVQ47wiRESdobCG4mpLRGSnEIPFMUh6A4';

export const GOOGLE_API_LINK = `https://www.googleapis.com/geolocation/v1/geolocate?key=${GOOGLE_API_KEY}`;

export const locationPermission = {
  GRANTED: 'granted',
  DENIED: 'denied',
  PROMPT: 'prompt',
};

export const automaticTime = {
  LOCATION: 10000,
};

export const AUTHEN_KEY = 'user';

export enum Locale {
  en,
  ja,
}

export const bindingType = {
  SUM: 'sum',
  COUNT: 'count',
  AVERAGE: 'avg',
  MIN: 'min',
  MAX: 'max',
  MIN_MAX: 'minMax',
  INPUT: 'input',
  DATE_TIME: 'dateTime',
  CURRENT_LOCATION: 'currentLocation',
  IMAGE_BINDING: 'imageBinding',
  FIELD: 'field',
  HAS_MANY_ONE_RELATIONSHIP: 'hasManyRelation',
  MANY_TO_MANY_RELATIONSHIP: 'manyToManyRelation',
  BE_LONG_RELATIONSHIP: 'belongsToRelation',
  DATA: 'data',
  CUSTOMACTION: 'customAction',
  PLUGIN: 'plugin',
  PAYMENT: 'payment',
  LIVESTREAM: 'liveStream',
  IMAGE_UPLOAD_LIST: 'imageUploadList',
  SELECT_LIST: 'selectList',
  CHANGE_QUANTITY: 'changeQuantity',
  APP_INFO: 'appInfo',
};

export const DEBOUNCE_TIME = 300;

export const dataBindingType = [
  'dataBinding',
  'items',
  'markerCollection',
  'database',
];

export const typeBindings = ['binding', 'formula'] as const;

export const listItemKey = ['children', 'columns'];

export const ignoreKeyBinding = ['fields', 'actions'];

export const defaultPathComponent: any = {
  [ComponentType.label]: 'text',
  [ComponentType.input]: 'defaultValue',
  [ComponentType.password]: 'defaultValue',
  [ComponentType.imageUpload]: 'defaultValue',
  [ComponentType.select]: 'defaultValue',
  [ComponentType.datePicker]: 'defaultDateValue',
};

export const ActionStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
  ERROR: 'ERROR',
};

export const SIGN_KEY = '123';

export const formControlType = [
  'image-upload',
  'checkbox',
  'date-picker',
  'file-upload',
];

export const ODER_LIST: { [key: string]: number } = {
  asc: -1,
  desc: 1,
};

export const listObject = [
  'list',
  'SimpleList',
  'CardList',
  'HorizontalCardList',
  'HorizontalCardList',
  'ChipList',
  'AvatarList',
  'Calendar',
  'Carousel',
  'select',
  'CustomHorizontalList',
  'RankingList',
  'SelectList',
  'LivestreamChat',
  // 'Table',
];

export const bindingComponentType = {
  SIMPLE: 'simple',
  MULTIPLE: 'multiple',
};

export const inputLibrary = ['Toggle', 'Switch', 'SelectList'];

export const CURRENT_LOCATION_KEY = 'currentLocation';

export const Method = {
  FIND: 'find',
  GET: 'get',
  CREATE: 'create',
  UPDATE: 'update',
  PATCH: 'patch',
  REMOVE: 'remove',
};

export const INPUT_TYPE = ['objectId', 'selectObjectId'];

export const TABLE_DELETE = 'table_delete';

export const PAGE_MAXIMUM_ITEM = 500;

export const isShowLoadingAction = [
  'label',
  'image',
  'section',
  'Icon',
  'ActionButton',
  'Button',
  'CustomButton',
  'LineLogin',
];
export enum Selector {
  CREATED_OBJECT = 'CREATED_OBJECT',
  CURRENT_USER_SELECTOR = 'CURRENT_USER_SELECTOR',
  ROUTE_PARAM_SELECTOR = 'ROUTE_PARAM_SELECTOR',
  LIST_ITEM_SELECTOR = 'LIST_ITEM_SELECTOR',
  SELECT_VALUE_SELECTOR = 'SELECT_VALUE_SELECTOR',
}
